import { ResolutionString } from "../../../../public/static/charting_library/charting_library";

export const timeDeltaMapping = (t: string | number) => {
  if (typeof t == 'string') {
    if (
      t.toLowerCase().includes('d') ||
      t.toLowerCase().includes('q') ||
      t.toLowerCase().includes('s')
    ) {
      return t.toLowerCase();
    }
  }
  t = +t;
  if (t < 60) {
    // under minutes
    return t + 'm';
  }
  let ans: string;
  if (t < 1440) {
    // under hours
    ans = Math.round(t / 60) + 'h';
  } else {
    // under days
    ans = Math.round(t / 60 / 24) + 'd';
  }
  return ans;
};

export const silentPriceCache = {};

export const PRICE_PROVIDER = 'RVA Exchange';

export const SUPPORTED_RESOLUTIONS = [
  // '1S' as ResolutionString,
  // '10S' as ResolutionString,
  '1' as ResolutionString, // min
  '3' as ResolutionString, // min
  '5' as ResolutionString, // min
  '10' as ResolutionString,
  '15' as ResolutionString,
  '30' as ResolutionString,
  '1H' as ResolutionString,
  '2H' as ResolutionString,
  '4H' as ResolutionString,
  '1D',
  '7D',
];

export const isntAvailable = (s: string | null) => {
  return (
    s && ['1s', '10s', '5m', '60', '120', '240', '1d'].includes(s.toLowerCase())
  );
};

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const formatResolution = (s: string) => {
  if (s.toLowerCase() == '1s') {
    return '1s';
  }
  if (s.toLowerCase() == '10s') {
    return '10s';
  }
  if (s.toLowerCase() == '1') {
    return '1m';
  }
  if (s.toLowerCase() == '5') {
    return '5m';
  }
  if (s.toLowerCase() == '3') {
    return '3m';
  }
  if (s.toLowerCase() == '15') {
    return '15m';
  }
  if (s.toLowerCase() == '10') {
    return '10m';
  }
  if (s.toLowerCase() == '30') {
    return '30m';
  }
  if (s.toLowerCase() == '60') {
    return '1h';
  }
  if (s.toLowerCase() == '120') {
    return '2h';
  }
  if (s.toLowerCase() == '240') {
    return '4h';
  }
  if (s.toLowerCase() == '1d') {
    return '1d';
  }
  return s;
};
